// package: profile
// file: apigateway/profile/master.proto

import * as apigateway_profile_master_pb from "../../apigateway/profile/master_pb";
import * as profileservice_master_pb from "../../profileservice/master_pb";
export class MasterService {
  static serviceName = "profile.MasterService";
}
export namespace MasterService {
  export class GetPrefectures {
    static readonly methodName = "GetPrefectures";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetRequest;
    static readonly responseType = apigateway_profile_master_pb.PrefectureReply;
  }
  export class GetThemes {
    static readonly methodName = "GetThemes";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetRequest;
    static readonly responseType = apigateway_profile_master_pb.ThemeReply;
  }
  export class GetDaysToDeliveries {
    static readonly methodName = "GetDaysToDeliveries";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetRequest;
    static readonly responseType = apigateway_profile_master_pb.DaysToDeliveryReply;
  }
  export class GetMinimumPrices {
    static readonly methodName = "GetMinimumPrices";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetRequest;
    static readonly responseType = apigateway_profile_master_pb.MinimumPriceReply;
  }
  export class GetJobs {
    static readonly methodName = "GetJobs";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetRequest;
    static readonly responseType = apigateway_profile_master_pb.JobReply;
  }
  export class GetAwardKinds {
    static readonly methodName = "GetAwardKinds";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetRequest;
    static readonly responseType = apigateway_profile_master_pb.AwardKindReply;
  }
  export class GetBlogPriceList {
    static readonly methodName = "GetBlogPriceList";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetBlogPriceListRequest;
    static readonly responseType = apigateway_profile_master_pb.GetBlogPriceListReply;
  }
  export class GetProviderJobs {
    static readonly methodName = "GetProviderJobs";
    static readonly service = MasterService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_master_pb.GetProviderJobsRequest;
    static readonly responseType = apigateway_profile_master_pb.GetProviderJobsReply;
  }
}
